module.exports = __webpack_public_path__ + "static/media/02.68c60416.png";